export default Object.freeze({
  VIEW_LOGIN: {
    id: "VIEW0000",
    path: "/login",
    name: "Login"
  },
  VIEW_PASSWORD_EDIT: {
    id: "VIEW0001",
    path: "/membership/password/edit",
    name: "PasswordEdit"
  },
  VIEW_TOP: {
    id: "VIEW0002",
    path: "/",
    name: "Top"
  },
  VIEW_SEARCH_PLAN: {
    id: "VIEW0003",
    path: "/plan-select/search",
    name: "SearchPlan"
  },
  VIEW_CONSTRUCT_INPUT: {
    id: "VIEW0004",
    path: "/plan/constr/input",
    name: "ConstructInput"
  },
  VIEW_PLAN_DETAIL: {
    id: "VIEW0005",
    path: "/plan/detail",
    name: "PlanDetail"
  },
  VIEW_PLAN_COMPLETE: {
    id: "VIEW0041",
    path: "/plan/complete",
    name: "PlanComplete"
  },
  VIEW_NOTICE: {
    id: "VIEW0006",
    path: "/notice",
    name: "Notice"
  },
  VIEW_NOTICE_DETAIL: {
    id: "VIEW0007",
    path: "/notice/detail",
    name: "NoticeDetail"
  },
  VIEW_MAIL_ADDESS: {
    id: "VIEW0008",
    path: "/membership/provisional/mail",
    name: "MailAddress"
  },
  VIEW_SAVED_PLAN_LIST: {
    id: "VIEW0011",
    path: "/mypage",
    name: "SavedPlanList"
  },
  VIEW_SAVED_PLAN_DETAIL: {
    id: "VIEW0012",
    path: "/mypage/saved-plan/detail",
    name: "SavedPlanDetail"
  },
  VIEW_FINANCING_PLAN: {
    id: "VIEW0013",
    path: "/mypage/financing-plan",
    name: "FinancingPlan"
  },
  VIEW_MEMBERSHIP_REGIST: {
    id: "VIEW0014",
    path: "/membership/regist",
    name: "MemberInfoRegist"
  },
  VIEW_CONTACT: {
    id: "VIEW0015",
    path: "/contact",
    name: "Contact"
  },
  VIEW_DOCUMENT_OFFER: {
    id: "VIEW0016",
    path: "/mypage/document-offer",
    name: "DocumentOffer"
  },
  VIEW_MOVING_QUOTATION: {
    id: "VIEW0017",
    path: "/mypage/moving-quotation",
    name: "MovingQuotation"
  },
  VIEW_CONTRACT: {
    id: "VIEW0018",
    path: "/mypage/contract",
    name: "Contract"
  },
  VIEW_PLAN_DELETE_COMPLETE: {
    id: "VIEW0019",
    path: "/mypage/saved-plan/deleteComplete",
    name: "SavedPlanDeleteComplete"
  },
  VIEW_PLAN_UPDATE_COMPLETE: {
    id: "VIEW0020",
    path: "/mypage/saved-plan/updateComplete",
    name: "SavedPlanUpdateComplete"
  },
  VIEW_FINANCING_PLAN_IMAGE_DISP: {
    id: "VIEW0021",
    path: "/FinancingPlanImageDisp/:imgSrc",
    name: "FinancingPlanImageDisp"
  },
  VIEW_SCHEDULE: {
    id: "VIEW0071",
    path: "/mypage/schedule/",
    name: "Schedule"
  },
  VIEW_VIA_LOGIN: {
    id: "VIEW0072",
    path: "/via/login",
    name: "ViaLogin"
  },
  VIEW_COMPLETEWITNESS: {
    id: "VIEW0073",
    path: "/mypage/completeWitness",
    name: "CompleteWitness"
  },
  VIEW_TRANSFER: {
    id: "VIEW0074",
    path: "/mypage/transfer",
    name: "Transfer"
  },
  VIEW_LIV_PLAN: {
    id: "VIEW0201",
    path: "/top/livPlanList",
    name: "LivPlanList"
  },

  // ここから静的ページ
  VIEW_SERVICE: {
    id: "VIEW1002",
    path: "/service",
    name: "Service"
  },
  VIEW_BASIC_STRUCTURE: {
    id: "VIEW1003",
    path: "/basicstructure",
    name: "Basicstructure"
  },
  VIEW_STANDARD_SPEC: {
    id: "VIEW1004",
    path: "/standardspecifications",
    name: "Standardspecifications"
  },
  VIEW_COMPANY: {
    id: "VIEW1005",
    path: "/company",
    name: "Company"
  },
  VIEW_TERMS: {
    id: "VIEW1006",
    path: "/terms",
    name: "Terms"
  },
  VIEW_PRIVACY_POLICY: {
    id: "VIEW1007",
    path: "/privacypolicy",
    name: "PrivacyPolicy"
  },
  VIEW_RESERVATION: {
    id: "VIEW1008",
    path: "/reservation",
    name: "Reservation"
  },
  VIEW_SITE_POLICY: {
    id: "VIEW1009",
    path: "/sitepolicy",
    name: "SitePolicy"
  },
  VIEW_SNS_POLICY: {
    id: "VIEW1010",
    path: "/snspolicy",
    name: "SnsPolicy"
  },
  VIEW_PW_REISSUE: {
    id: "VIEW0022",
    path: "/membership/password/reissue",
    name: "PasswordReissue"
  },
  VIEW_DOCUMENT_DOWNLOAD: {
    id: "VIEW0023",
    path: "/mypage/document-download",
    name: "DocumentDownload"
  },
  VIEW_DOCUMENT_UPLOAD: {
    id: "VIEW0024",
    path: "/mypage/document-upload",
    name: "DocumentUpload"
  },
  VIEW_IMPROVE_GRUND: {
    id: "VIEW1024",
    path: "/improveGround",
    name: "ImproveGround"
  },
  VIEW_VARYS_LINEUP: {
    id: "VIEW2001",
    path: "/top/varysLineUp",
    name: "VarysLineUp"
  },
  VIEW_VARYS_FLOOR: {
    id: "VIEW2002",
    path: "/top/varysLineUp/varysFloor",
    name: "VarysFloor"
  },
  VIEW_MAILAUTHKEY_EXPIRED: {
    id: "VIEW1026",
    path: "/mailAuthKeyExpired",
    name: "MailAuthKeyExpired"
  },
  VIEW_STANDARD_SPEC_VARYS: {
    id: "VIEW1011",
    path: "/standardSpecificationsVarys",
    name: "StandardSpecificationsVarys"
  },
  VIEW_STORE_LIST: {
    id: "VIEW1012",
    path: "/storeList",
    name: "StoreList"
  },
  // モーダル:クローズボタンがデフォルト
  MODAL_OPTION: {
    closeOnBgClick: false,
    preloader: false,
    removalDelay: 300,
    mainClass: "mfp-fade",
    closeMarkup:
      '<div class="popupclose closebtn"><div><span></span></div></div>'
  },
  // モーダル:クローズボタンを別途追加要
  MODAL_NO_CLOSE: {
    closeOnBgClick: false,
    preloader: false,
    showCloseBtn: false,
    removalDelay: 300,
    mainClass: "mfp-fade"
  },
  // 契約ステータス
  CONTRACT_STATUS: {
    REGISTERING: "010", // 登録中
    UNDER_INSPECTION: "020", // 審査中
    REMAND: "030", // 差戻中
    INSPECTION_COMPLETE: "040", // 審査完了
    CONTRACT_STAMP_WAIT: "041", // 契約押印待ち
    CONTRACT_COMPLETE: "042", // 契約完了
    PLACEMENT_SPEC_APPROVAL_CONFIRM: "050", // 図面打合せ中
    PLACEMENT_SPEC_APPROVAL: "060", // 図面確定
    ADDITIONAL_FEE_APPROVAL_CONFIRM: "070", // 仕様打合せ中
    ADDITIONAL_FEE_APPROVAL: "080", // 仕様確定
    FINAL_DOCUMENT_PREPARATION: "081", // 最終契約書類準備中
    FINAL_INSPECTION_COMPLETE: "090", // 最終契約審査完了
    FINAL_STAMP_WAIT: "091", // 最終契約押印待ち
    FINAL_COMPLETE: "092", // 最終契約完了
    CONFIRM_APPLICATION_ISSUANCE_WAIT: "093", // 確認申請交付待ち
    CONFIRM_APPLICATION_ISSUANCE: "094", // 確認申請交付
    AFTER_APPLY_MODIFIED_CONFRIM: "100", // 確認申請後修正中
    AFTER_APPLY_MODIFIED: "110", // 確定図作成完了
    BEFORE_CONSTRUCTION_FINAL_FIX: "120", // 着工準備中
    GROUND_IMPROVEMENT_DMT_FEE_APPROVAL_CONFIRM: "130", // 事前工事着工
    GROUND_IMPROVEMENT_DMT_FEE_APPROVAL: "140", // 事前工事中
    DMT_START: "150", // 解体着工
    GROUND_IMPROVEMENT_DEMOLITION_FEE_APPROVAL_WAIT: "160", // 地盤改良費（解体ありの時）承認待ち
    GROUND_IMPROVEMENT_DEMOLITION_FEE_APPROVAL: "170", // 地盤改良費（解体ありの時）承認
    IMPROVEMENT_START: "180", // 改良着工
    FOUNDATION_START: "190", //基礎着工
    FIRST_TEST_BEFORE: "200", // 第１回検査前
    FIRST_TEST_AFTER: "210", // 第１回検査(配筋検査)
    SECOND_TEST_BEFORE: "220", // 第２回検査前
    SECOND_TEST_AFTER: "230", // 第２回検査(アンカー検査)
    THIRD_TEST_BEFORE: "240", // 第３回検査前
    THIRD_TEST_AFTER: "250", // 第３回検査(基礎完了検査)
    FOURTH_TEST_BEFORE: "260", // 第４回検査前
    FOURTH_TEST_AFTER: "270", // 第４回検査(土台検査)
    FIFTH_TEST_BEFORE: "280", // 第５回検査前
    FIFTH_TEST_AFTER: "290", // 第５回検査(工場検査)
    RIDGEPOLE_RAISING_BEFORE: "300", // 上棟前
    RIDGEPOLE_RAISING: "310", // 上棟
    SIXTH_TEST_BEFORE: "320", // 第６回検査前
    SIXTH_TEST_AFTER: "330", // 第６回検査(軸組・RF検査)
    SEVENTH_TEST_BEFORE: "340", // 第７回検査
    SEVENTH_TEST_AFTER: "350", // 第７回検査(断熱検査)
    EIGHTH_TEST_BEFORE: "360", // 第８回検査前
    EIGHTH_TEST_AFTER: "370", // 第８回検査(防水検査)
    NINTH_TEST_BEFORE: "380", // 第９回検査前
    NINTH_TEST_AFTER: "390", // 第９回検査(外装検査)
    TENTH_TEST_BEFORE: "400", // 第１０回検査前
    TENTH_TEST_AFTER: "410", // 第１０回検査(完成検査)
    COMPLETION: "420", // 竣工
    CLIENT_INSPECTION: "430", // 施主検査
    TRANSFER_BEFORE: "440", // 引渡し前
    TRANSFER: "450", // 引き渡し
    TRANSFER_AFTER_WITHIN_TWO_YEAR: "460", // 引き渡し後２年以内
    SHORT_TERM_INSURANCE_FINISH: "470", // 短期保証終了
    TRANSFER_AFTER_WITHIN_TEN_YEAR: "480", // 引き渡し後１０年以内
    LONG_TERM_INSURANCE_FINISH: "490", // 長期保証終了
    TRANSFER_AFTER_WITHIN_FIFTEEN_YEAR: "500", // 引き渡し後１５年以内
    HOUSING_FACILITY_INSURANCE_FINISH: "510", // 住宅設備保証終了
    TRANSFER_AFTER_FIFTEEN_YEAR_AFTER: "520" // 引き渡し後１５年以降
  },
  // 契約申込：ファイル管理区分
  FILE_MGR_TYPE: {
    OWNER_FILE: "C01", // 本人確認書類ファイル
    OWNER2_FILE: "C02", // 本人確認書類ファイル(連名契約者)
    LAND_CONTRACT_FILE: "C03", // 土地売買契約書ファイル
    LAND_EXPLAIN_FILE: "C04", // 土地重要事項説明書ファイル
    LAND_REGISTRATION_FILE: "C05", // 登記簿謄本(土地)ファイル
    BUILDING_REGISTRARION_FILE: "C06", // 登記簿謄本(建物)ファイル
    LAND_SURVEY_FILE: "C07", // 地積測量図ファイル
    OWNER_PROMISE_FILE: "C08", // 融資事前審査承諾書ファイル
    OWNER_PROMISE2_FILE: "C09", // 融資事前審査承諾書ファイル(連名契約者)
    MUTUAL_AID_FILE: "C10", // 共済の貸付ファイル
    MUTUAL_AID2_FILE: "C11", // 共済の貸付ファイル(連名契約者)
    HOUSING_PROPERTY_FILE: "C12", // 住宅財形ファイル
    HOUSING_PROPERTY2_FILE: "C13", // 住宅財形ファイル(連名契約者)
    DEPOSIT_FILE: "C14", // 預金ファイル
    RELATIVES_AID_FILE: "C15", // 親族からの援助ファイル
    OTHER_FILE: "C16" // その他ファイル
  },
  PLAN_GROUP_ID: {
    LIVNEX: "PgLivnex", // LIVNEX HOUSE LINEUP
    VARYS_ENG: "PgVaryEn" // VARYS ENGAGE FLOOR
  }
});
